import { memo, useMemo } from 'react'
import { Helmet } from 'react-helmet-async'

interface Props {
  offer: App.BundleOffer | App.HotelOffer | App.VillaOffer
}

function createHotelStructuredData(offer: App.BundleOffer | App.HotelOffer | App.VillaOffer) {
  const geoData = offer.property.geoData

  return {
    '@context': 'https://schema.org',
    '@type': 'Hotel',
    name: offer.property.name,
    description: offer.description,
    address: {
      '@type': 'PostalAddress',
      addressCountry: geoData?.countryCode,
      addressRegion: geoData?.administrativeAreaLevel1,
      addressLocality: geoData?.locality,
      streetAddress: offer.property.address,
    },
  }
}

function HotelStructuredData(props: Props) {
  const { offer } = props

  const structuredData = useMemo(() => createHotelStructuredData(offer), [offer])

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  )
}

export default memo(HotelStructuredData)
